// MIT License - Copyright (c) 2026 Doug McNall
const config = {
  apiUrl: process.env.REACT_APP_ADMIN_API_URL || process.env.REACT_APP_API_URL,
  environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV,
  debug: process.env.REACT_APP_DEBUG === 'true'
};

if (!config.apiUrl) {
  throw new Error('Missing REACT_APP_ADMIN_API_URL or REACT_APP_API_URL');
}

export default config;
